module.exports = __webpack_public_path__ + "img/home_banner_coins.3763c1c6.jpg";